import { render, staticRenderFns } from "./TelemetryCard.vue?vue&type=template&id=05c1458b&scoped=true&"
import script from "./TelemetryCard.vue?vue&type=script&lang=ts&"
export * from "./TelemetryCard.vue?vue&type=script&lang=ts&"
import style0 from "./TelemetryCard.vue?vue&type=style&index=0&id=05c1458b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c1458b",
  null
  
)

export default component.exports